var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { ReactiveInput } from './Input/Input';
import { ReactiveAccordion, ReactiveAccordionItem, Button, ReactiveCheckbox, ReactiveRadioGroup, ReactiveSwitch, ReactiveSelect, PlainText, Wizard, ReactiveTextArea, ReactiveFieldSet } from './';
import { FormCourseMeta } from './FormCourseMeta';
import { PriceBreakup } from '../PriceBreakup/PriceBreakup';
import { PriceSelect } from './PriceSelect/PriceSelect';
import { PaymentGateway, PaymentGatewayRadio } from './PaymentGatewayRadio/PaymentGatewayRadio';
import { ReactiveFormButtons } from './FormButtons/FormButtons';
import { ReactiveCartTable, ReactiveCartTableRow } from './CartTable';
import validatorMapperDataForms from '@data-driven-forms/react-form-renderer/dist/cjs/validator-mapper';
import { validateDate } from '../../helpers/date';
import { ReactiveSearchNSelect } from './SearchNSelect/SearchNSelect';
import { ReactiveCard } from './Card/Card';
import { ReactiveBasic } from './Basic/Basic';
import { ReactiveMenu } from './Menu/Menu';
import { ReactiveMenuItem } from './Menu/MenuItem';
import { ReactiveTimeSlot } from './TimeSlot/TimeSlot';
import { componentTypes as allComponentTypes } from "./componentTypes";
import { validatorTypes as allValidatorTypes } from "./validatorTypes";
import get from 'lodash/get';
import i18next from 'i18next';
import { ReactiveCouponCode } from './CouponCode/CouponCode';
export var componentTypes = allComponentTypes;
export var validatorTypes = allValidatorTypes;
export var componentMapper = (_a = {},
    _a[componentTypes.TEXT_FIELD] = ReactiveInput,
    _a[componentTypes.CHECKBOX] = ReactiveCheckbox,
    _a[componentTypes.RADIO] = ReactiveRadioGroup,
    _a[componentTypes.TEXTAREA] = ReactiveTextArea,
    _a[componentTypes.SELECT] = ReactiveSelect,
    _a[componentTypes.BUTTON] = Button,
    _a[componentTypes.PLAIN_TEXT] = PlainText,
    _a[componentTypes.BASIC] = ReactiveBasic,
    _a[componentTypes.WIZARD] = Wizard,
    _a[componentTypes.PRICE_BREAKUP] = PriceBreakup,
    _a[componentTypes.COURSE_META] = FormCourseMeta,
    _a[componentTypes.ACCORDION] = ReactiveAccordion,
    _a[componentTypes.ACCORDION_ITEM] = ReactiveAccordionItem,
    _a[componentTypes.SWITCH] = ReactiveSwitch,
    _a[componentTypes.PRICE_SELECT] = PriceSelect,
    _a[componentTypes.PAYMENT_GATEWAY] = PaymentGateway,
    _a[componentTypes.PAYMENT_GATEWAY_RADIO] = PaymentGatewayRadio,
    _a[componentTypes.FORM_BUTTONS] = ReactiveFormButtons,
    _a[componentTypes.FIELD_SET] = ReactiveFieldSet,
    _a[componentTypes.CART_TABLE] = ReactiveCartTable,
    _a[componentTypes.CART_TABLE_ROW_ITEM] = ReactiveCartTableRow,
    _a[componentTypes.SEARCH_N_SELECT] = ReactiveSearchNSelect,
    _a[componentTypes.CARD] = ReactiveCard,
    _a[componentTypes.MENU] = ReactiveMenu,
    _a[componentTypes.MENU_ITEM] = ReactiveMenuItem,
    _a[componentTypes.TIME_SLOT] = ReactiveTimeSlot,
    _a[componentTypes.COUPON_CODE] = ReactiveCouponCode,
    _a);
export var validatorMapper = __assign(__assign({}, validatorMapperDataForms), (_b = {}, _b[validatorTypes.DATE] = function () { return validateDate; }, _b[validatorTypes.CONFIRM_EMAIL] = function () { return function (value, allValues, meta) {
    var name = meta.name;
    var confirmValue = get(allValues, name.replace("email_confirmed", "email"));
    return confirmValue === value ? "" : i18next.t('errors.emails_do_not_match');
}; }, _b));
